import { useSelector } from "react-redux";
import { Outlet } from "react-router";
import Header from "../header/Header";

const Home = (props) => {
  const { account, facility, isLayoutMode } = useSelector(({ account, facility, common }) => ({
    account,
    facility,
    isLayoutMode: common.isLayoutMode,
  }));

  return (
    <div className={`df`} style={{ height: "100%" }}>
      <Header isLayoutMode={isLayoutMode} />
      {facility !== "refreshing" && account !== "refreshing" ? (
        <Outlet />
      ) : undefined}
    </div>
  );
};

export default Home;
